import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createMultilevelApproval,
  fetchmultilevelApproval,
} from "../../../services/multiLevelApprovalService";
import {
  createMultiLevelApprovalThunk,
  deleteMultiLevelApprovalThunk,
  updateMultiLevelApprovalThunk,
} from "../thunks/thunks";

// Async thunk to fetch designation data
export const fetchmultilevelApprovalAsync = createAsyncThunk(
  "multilevelapproval/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchmultilevelApproval();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const createMultilevelApprovalAysc = createAsyncThunk(
  "multilevelapproval/createDesignation",
  async (multilevelData, { rejectWithValue }) => {
    try {
      const response = await createMultilevelApproval(multilevelData);
      return response.data;
    } catch (error) {
      console.error("Error creating role:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const multiLevelSlice = createSlice({
  name: "multilevel",
  initialState: {
    multilevelApprovalData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createMultiLevelApprovalThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMultiLevelApprovalThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.multilevelApprovalData.push(action.payload);
      })
      .addCase(createMultiLevelApprovalThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchmultilevelApprovalAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchmultilevelApprovalAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.multilevelApprovalData = action.payload;
      })
      .addCase(fetchmultilevelApprovalAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createMultilevelApprovalAysc.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMultilevelApprovalAysc.fulfilled, (state, action) => {
        state.loading = false;
        state.multilevelApprovalData.push(action.payload);
      })
      .addCase(createMultilevelApprovalAysc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateMultiLevelApprovalThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMultiLevelApprovalThunk.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.multilevelApprovalData.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.multilevelApprovalData[index] = action.payload;
        }
      })
      .addCase(updateMultiLevelApprovalThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteMultiLevelApprovalThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMultiLevelApprovalThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.multilevelApprovalData = state.multilevelApprovalData.filter(
          (item) => item.id !== action.payload
        );
      })
      .addCase(deleteMultiLevelApprovalThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default multiLevelSlice.reducer;
